import * as TYPES from './types';
export default {
    [TYPES.SET_INFO](payload) {
        Object.assign(this.info, payload);
    },
    [TYPES.SET_LISTING](payload) {
        this.result.listings = payload;
    }
};
